// extracted by mini-css-extract-plugin
export var resizer = "_hh-0";